































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import loader from "@/components/loader.vue";

import { momentTZ as moment } from "@/helpers/moment";
import billingApi from "@/services/billing";
import { debounce, cancel } from "typescript-debounce-decorator";
import { Action, Getter, Mutation } from "vuex-class";

import { NSLog } from "@/helpers/log";
const log = NSLog("view/ManageBundles");

import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
import EssentialsPlugin from "@ckeditor/ckeditor5-essentials/src/essentials";
import BoldPlugin from "@ckeditor/ckeditor5-basic-styles/src/bold";
import ItalicPlugin from "@ckeditor/ckeditor5-basic-styles/src/italic";
import ParagraphPlugin from "@ckeditor/ckeditor5-paragraph/src/paragraph";
import FontPlugin from "@ckeditor/ckeditor5-font/src/font";
import BundleHelpers, { Bundle } from "@/models/bundle";
import { Package } from "@/models/package";

@Component({
  components: {
    loader
  }
})
export default class EditPackageDialog extends Vue {
  @Prop({ required: true }) public value!: boolean;
  @Prop({ required: false, default: false }) public packages!: Package[] | false;
  @Prop({ required: false }) filterCurrency?: string;

  loading = false;
  search = "";
  list!: Package[];

  get filterred() {
    if (!this.search.length) return [...this.list];
    const search = this.search.toLocaleLowerCase();
    return this.list.filter((p) =>
      p.title.toLocaleLowerCase().indexOf(search) > -1
      || p.description.toLocaleLowerCase().indexOf(search) > -1
    )
    // this.list.filter()
  }

  public mounted() {
    this.refreshPackages();
  }

  @Getter("packages") storePackages!: Package[];

  private async refreshPackages() {
    this.loading = true;
    try {
      let list: Package[];
      if (this.packages) {
        list = this.packages;
      } else if (this.storePackages) {
        list = this.storePackages;
      } else {
        list = await billingApi.listPackages();
      }
      this.list = list.filter((p) => p.is_visible_now && (
        this.filterCurrency ? this.filterCurrency == p.currency : true
      ));
    } catch (err) {
      this.list = [];
      log("err", err);
    }

    this.loading = false;
  }

  selectPackage(pkg: Package) {
    this.$emit('input', pkg)
  }

  public headers = [
    { text: "Code", value: "code" },
    {
      text: "Title",
      align: "left",
      sortable: true,
      value: "title"
    },

    { text: "Interval", value: "interval" },
    { text: "Price", value: "price" },
    // { text: "Currency", value: "currency" },
    // { text: "Updated", value: "updated_at" },

    { text: "Cart Description", value: "description" },
  ];
}
